export var NAME='BvConfig';export var PROP_NAME='$bvConfig';export var DEFAULT_BREAKPOINT=['xs','sm','md','lg','xl'];